/** Cross-reference mantras linked to deities and practices */
export const MANTRAS = [
  {
    id: "om_gam_ganapataye",
    name: "Gaṇeśa bija",
    deity_id: "ganesha",
    text: "ॐ गं गणपतये नमः",
    beginner_summary: "Removes obstacles before any auspicious work.",
    meaning: "Salutation to Gaṇapati, lord of gaṇas (categories of beings).",
    usage: "108× at dawn before study or travel.",
  },
  {
    id: "om_namah_shivaya",
    name: "Pañcākṣarī",
    deity_id: "shiva",
    text: "ॐ नमः शिवाय",
    beginner_summary: "Five syllables honoring Śiva — refuge and purification.",
    meaning: "Om, salutations to Śiva.",
    usage: "Japa with rudrākṣa; especially Pradoṣa and Śivarātri.",
  },
  {
    id: "om_namo_narayanaya",
    name: "Nārāyaṇa mantra",
    deity_id: "vishnu",
    text: "ॐ नमो नारायणाय",
    beginner_summary: "Core Viṣṇu refuge mantra for Ekādaśī and daily bhakti.",
    meaning: "Salutation to Nārāyaṇa, refuge of all beings.",
    usage: "Ekādaśī, sandhyā, or continuous nāma smaraṇa.",
  },
  {
    id: "rama_nama",
    name: "Rāma nāma",
    deity_id: "rama",
    text: "श्री राम जय राम जय जय राम",
    beginner_summary: "Simplest mahā-mantra in Kali age per tradition.",
    meaning: "Victory to Rāma — name equals presence.",
    usage: "Walking, working, mālā japa without limit.",
  },
  {
    id: "gayatri",
    name: "Gāyatrī",
    deity_id: "saraswati",
    text: "ॐ भूर्भुवः स्वः तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि धियो यो नः प्रचोदयात्",
    beginner_summary: "Solar wisdom mantra for sandhyā.",
    meaning: "We meditate on divine light to illumine intellect.",
    usage: "Dawn sandhyā with proper adhikāra per lineage.",
  },
];

export function getMantra(id) {
  return MANTRAS.find((m) => m.id === id) ?? null;
}
